function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 49,
  height: 49,
  stroke: "#2D577D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5905 41.0131L22.0518 36.75L26.9745 36.75L29.4358 41.0131L26.9745 45.2763L22.0518 45.2763L19.5905 41.0131Z",
  fill: "#047E2E",
  fillOpacity: 0.5,
  stroke: "#047E2E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5905 30.5131L22.0518 26.25L26.9745 26.25L29.4358 30.5131L26.9745 34.7763L22.0518 34.7763L19.5905 30.5131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5905 20.0131L22.0518 15.75L26.9745 15.75L29.4358 20.0131L26.9745 24.2763L22.0518 24.2763L19.5905 20.0131Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5905 9.51314L22.0518 5.25L26.9745 5.25L29.4358 9.51314L26.9745 13.7763L22.0518 13.7763L19.5905 9.51314Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

function SvgLance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    className: "bg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLance);
export default __webpack_public_path__ + "static/media/lance.a1b11bd3.svg";
export { ForwardRef as ReactComponent };